export default [
  {
    path: '/peihu/peihu',
    component: () => import('./views/peihu')
  }
]



// WEBPACK FOOTER //
// ./src/page/peihu/route.js